<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    data () {
        return {
            error: null
        }
    },
    created () {
        this.$store.dispatch('load')
    },
    methods: {
        showError (message) {
            this.$toast.error(message)
        }
    }
}
</script>

<style lang="scss">
    @import 'public/css/app';
</style>
